module.exports = __webpack_public_path__ + "static/media/down-arrow.24465889.svg";